export function indexTouches(touches, points) {
    if (touches.length !== points.length)
        throw new Error(`The number of touches and points are not equal - touches ${touches.length}, points ${points.length}`);
    const obj = {};
    for (let i = 0; i < touches.length; i++) {
        obj[touches[i].identifier] = points[i];
    }
    return obj;
}
//# sourceMappingURL=handler_util.js.map